import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

const fmt = (v) => {
  const n = parseFloat(String(v).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(n) ? "" : n.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

// Currency entry: raw digits while typing, $x,xxx.xx on blur. onChange receives
// the raw numeric string so calculations and payloads are unaffected.
export function CurrencyInput({ value, onChange, testId, ...rest }) {
  const [focused, setFocused] = useState(false);
  const [text, setText] = useState(value ?? "");
  useEffect(() => { if (!focused) setText(value ?? ""); }, [value, focused]);
  return (
    <Input inputMode="decimal" className="rounded-sm" data-testid={testId}
      value={focused ? text : (text === "" || text === null ? "" : fmt(text))}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9.]/g, "");
        setText(raw);
        onChange(raw);
      }}
      {...rest} />
  );
}
